import {graphql} from '~/graphql-react-query/';

export const CreativeEmailSegmentCreate = graphql(`
    mutation CreativeEmailSegmentCreate($input: SegmentV2CreateInput!) {
        segmentV2 {
            segmentCreate(input: $input) {
                id
                name
                color
                teamId
                teamName
                description
                definitionV2
                emailAlert
                author {
                    id
                    name
                    email
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
                createdAt
                updatedAt
                status
            }
        }
    }
`);

export const CreativeEmailSegmentUpdate = graphql(`
    mutation CreativeEmailSegmentUpdate($input: CreativeEmailSegmentUpdateInput!) {
        segmentV2 {
            creativeEmailSegmentUpdate(input: $input) {
                id
                name
                color
                teamId
                description
                definitionV2
                emailAlert
                author {
                    id
                    name
                    email
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
                createdAt
                updatedAt
                status
            }
        }
    }
`);

export const CreativeEmailSegmentQuery = graphql(`
    query CreativeEmailSegmentQuery($input: CreativeEmailSegmentInput) {
        segmentV2 {
            creativeEmailSegment(input: $input) {
                id
                name
                color
                teamId
                description
                definitionV2
                emailAlert
                author {
                    id
                    name
                    email
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
                createdAt
                updatedAt
                status
            }
        }
    }
`);

export const SegmentCreateMutation = graphql(`
    mutation SegmentCreateMutation($input: SegmentV2CreateInput!) {
        segmentV2 {
            segmentCreate(input: $input) {
                id
                name
                color
                teamId
                teamName
                description
                definitionV2
                author {
                    id
                    name
                    email
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
                createdAt
                updatedAt
                status
                emailAlert
            }
        }
    }
`);

export const SegmentListQuery = graphql(`
    query SegmentListQuery($input: SegmentListOptions) {
        segmentV2 {
            segmentList(input: $input) {
                data {
                    id
                    name
                    color
                    teamId
                    teamName
                    description
                    definitionV2
                    emailAlert
                    author {
                        id
                        name
                        email
                    }
                    sharing {
                        status
                        usersWithAccess {
                            id
                            name
                            email
                        }
                    }
                    createdAt
                    updatedAt
                    status
                }
            }
        }
    }
`);

export const SegmentUpdateMutation = graphql(`
    mutation SegmentUpdateMutation($input: SegmentV2UpdateInput!) {
        segmentV2 {
            segmentUpdate(input: $input) {
                id
                name
                color
                teamId
                teamName
                description
                definitionV2
                emailAlert
                author {
                    id
                    name
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                    }
                }
                createdAt
                updatedAt
                status
            }
        }
    }
`);

export const SegmentRemoveMutation = graphql(`
    mutation SegmentRemoveMutation($id: UUID!) {
        segmentV2 {
            segmentRemove(id: $id)
        }
    }
`);

export const SegmentV2Query = graphql(`
    query SegmentV2Query($id: UUID!, $includeDeleted: Boolean, $ignoreSharing: Boolean) {
        segmentV2 {
            segment(id: $id, includeDeleted: $includeDeleted, ignoreSharing: $ignoreSharing) {
                id
                name
                color
                teamId
                teamName
                description
                definitionV2
                emailAlert
                author {
                    id
                    name
                    email
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                        email
                    }
                }
                createdAt
                updatedAt
                status
            }
        }
    }
`);

export const SegmentRemoveManyMutation = graphql(`
    mutation SegmentRemoveMany($ids: [UUID!]!) {
        segmentV2 {
            segmentRemoveMany(ids: $ids) {
                data {
                    id
                    name
                    color
                    description
                    author {
                        name
                        id
                    }
                    teamId
                    teamName
                    sharing {
                        status
                        usersWithAccess {
                            id
                            name
                        }
                    }
                    createdAt
                    updatedAt
                    status
                }
            }
        }
    }
`);

export const SegmentShareManyMutation = graphql(`
    mutation SegmentShareMany($input: SegmentV2ShareManyInput!) {
        segmentV2 {
            segmentShareMany(input: $input) {
                data {
                    id
                    name
                    color
                    description
                    author {
                        name
                        id
                    }
                    teamId
                    teamName
                    sharing {
                        status
                        usersWithAccess {
                            id
                            name
                        }
                    }
                    createdAt
                    updatedAt
                    status
                }
            }
        }
    }
`);

export const SegmentSearchQuery = graphql(`
    query SegmentSearchQuery($input: SegmentSearchInput!) {
        segmentV2 {
            segmentSearch(input: $input) {
                data {
                    id
                    name
                    color
                    description
                    author {
                        name
                        id
                        email
                    }
                    teamId
                    teamName
                    sharing {
                        status
                        usersWithAccess {
                            id
                            name
                            email
                        }
                    }
                    createdAt
                    updatedAt
                    status
                    emailAlert
                }
            }
        }
    }
`);

export const SegmentNzUnsubsribeMutation = graphql(`
    mutation SegmentNzUnsubsribeMutation($teamId: UUID!) {
        segmentV2 {
            nzUnsubscribe(teamId: $teamId)
        }
    }
`);
